import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const revenueAPI = createApi({
    reducerPath: "revenueAPI",
    baseQuery,
    endpoints: (builder) => ({
        getRevenueSummary: builder.query({
            query: ({startDate, endDate, includeTaxes=false}) => {
                let apiUrl = `revenue/summary`;

                if (startDate && endDate) {
                    apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
                }

                if (includeTaxes) {
                    apiUrl += `&includeTaxes=${includeTaxes}`;
                }

                return {
                    url: apiUrl,
                    method: 'GET',
                };
            },
            transformResponse: (response) => response,
            providesTags: ["revenueSummary"],
        }),
        getRevenueLogs: builder.query({
            query: ({type, page, size, startDate, endDate}) => {
                let apiUrl = `revenue/admin-logs?type=${type}&page=${page + 1}&size=${size}`;

                if (startDate && endDate) {
                    apiUrl += `?startDate=${startDate}&endDate=${endDate}`;
                }

                return {
                    url: apiUrl,
                    method: 'GET'
                };
            },
            transformResponse: (response) => response,
            keepUnusedDataFor: 0
        })
    }),
});

export const {
    useGetRevenueSummaryQuery,
    useGetRevenueLogsQuery
} = revenueAPI;

export default revenueAPI;
